import { BaseEntity } from "./BaseEntity";

export class CollaboratorEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.rhdigital.hrManagement.collaborator.entity";
        this.pageTitle = "components.rhdigital.hrManagement.collaborator.management";
        this.menuPath = "/rhdigital/hr-management";
        this.APIRoute = "Resources/HR Management/Collaborator";
        this.i18nBase = "components.rhdigital.hrManagement.collaborator";
        this.baseEndPoint = "/rh/colaborador";

        this.endpoints = {
            list: this.baseEndPoint,
            create: this.baseEndPoint,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
        };

        this.fields = [
            {
                key: "id",
                label: "user.fields.id",
                type: "hidden",
                visible: false,
                editable: false,
                orderBy: false
            },
            {
                key: "codigo",
                label: `${this.i18nBase}.fields.codigo`,
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                maxlength: 10,
                path: "codigo"
            },
            {
                key: "nome",
                label: `${this.i18nBase}.fields.nome`,
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                maxlength: 80,
                path: "nome"
            },
            {
                key: "email",
                label: `${this.i18nBase}.fields.email`,
                type: "email",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                maxlength: 50,
                path: "email"
            },
            {
                key: "data_admissao",
                label: `${this.i18nBase}.fields.data_admissao`,
                type: "date",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "data_admissao"
            },
            {
                key: "user_id",
                label: `${this.i18nBase}.fields.user_id`,
                type: "autocomplete",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                searchHandler: "handleSearchUser",
                options: [],
                path: "user_id"
            },
            {
                key: "foto",
                label: `${this.i18nBase}.fields.foto`,
                type: "upload",
                visible: true,
                editable: true,
                cols: 6,
                titulo: `${this.i18nBase}.photoDropTitle`,
                subtitulo: `${this.i18nBase}.photoMaxSize`,
                previewAlt: `${this.i18nBase}.photoPreviewAlt`,
                replaceText: `${this.i18nBase}.replacePhoto`,
                removeText: `${this.i18nBase}.removePhoto`,
                invalidTypeText: `${this.i18nBase}.photoInvalidType`,
                maxSizeText: `${this.i18nBase}.photoMaxSize`,
                accept: "image/*",
                maxSize: 2 * 1024 * 1024,
                path: "foto"
            },
            {
                key: "status",
                label: "common.labels.status",
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 6,
                path: "status"
            },
        ];

        this.customActions = {
            duplicate: false
        };

        this.tableColumns = [
            {
                key: "codigo",
                label: `${this.i18nBase}.fields.codigo`,
                visible: true,
                orderBy: true
            },
            {
                key: "nome",
                label: `${this.i18nBase}.fields.nome`,
                visible: true,
                orderBy: true
            },
            {
                key: "email",
                label: `${this.i18nBase}.fields.email`,
                width: "145px",
                smallScreenWidth: "100px",
                smallScreenMaxChars: 24,
                visible: true,
                orderBy: true
            },
            {
                key: "data_admissao",
                label: `${this.i18nBase}.fields.data_admissao`,
                width: "145px",
                smallScreenWidth: "100px",
                smallScreenMaxChars: 24,
                visible: true,
                orderBy: true
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ];

        this.pages = {
            view: {
                pageTitle: `${this.i18nBase}.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.HR Management/${this.i18nBase}.management`,
                route: ["/rhdigital/hr-management", "/rhdigital/hr-management/collaborators", "/rhdigital/hr-management/collaborator/edit/:id"]
            },
            edit: {
                pageTitle: `${this.i18nBase}.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.HR Management/${this.i18nBase}.management`,
                route: ["/rhdigital/hr-management", "/rhdigital/hr-management/collaborators", "/rhdigital/hr-management/collaborator/edit/:id"]
            },
            create: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: `components.settings.permissionManagement.menuList.HR Management/${this.i18nBase}.management`,
                route: ["/rhdigital/hr-management", "/rhdigital/hr-management/collaborators", "/rhdigital/hr-management/collaborator/create"]
            },
            list: {
                pageTitle: `${this.i18nBase}.management`,
                pathI18n: "components.settings.permissionManagement.menuList.HR Management",
                route: ["/rhdigital/hr-management", "/rhdigital/hr-management/collaborators"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["nome"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "email",
                                type: "text",
                                label: `${this.i18nBase}.fields.email`,
                                path: "email"
                            },
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: "ativo" },
                                    { label: "common.labels.inactive", value: "inativo" },
                                ],
                                path: "status"
                            },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
